export default __webpack_public_path__ + "static/media/Tripti Bhardwaj.cd41f760.png";